module.exports = __webpack_public_path__ + "static/media/jsqWrap.73078f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jsqWrap.png
// module id = 1790
// module chunks = 0 1